import React, { useEffect, useRef, useState } from "react";
import { Box, Flex } from "theme-ui";


const SortComp = ({ items, refine, sortingIndex }) => {
  const ref = useRef();
  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState("Alphabet");
  const [order, setOrder] = useState(true);
    

  useEffect(() => {
    const checkIfClickedOutside = e => {
      if (open && ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [open]);

  useEffect(()=>{
    setOrder(true);
    refine("Alphabet", true);
  }, []);

  useEffect(()=>{
    const sortingIndexName = sortingIndex(selectedValue, order);
    refine(sortingIndexName);
  }, [order, selectedValue]);


  return (
    <div className="sort_comp">
      <div className="sort_container">
        <button
          type="button"
          className="sort_menu_button"
          onClick={() =>{ setOpen(!open);}}
        >
          {selectedValue}
        </button>

        {open && (
          <div className="sort_dropdown" ref={ref}>
            <ul>
              {items.map((item) => (
                // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                <li
                  role="menuitem"
                  key={item.label}
                  onClick={() => {
                    setSelectedValue(item.label);
                    setOpen(!open);
                    setOrder(true);
                  }}
                >
                  <Flex
                    sx={{
                      width: "100%",
                      justifyContent: "space-between",
                      fontWeight:
                        selectedValue === item?.label ? "bold" : "normal",
                    }}
                  >
                    <Box>{item.label}</Box>{" "}
                    {selectedValue === item?.label ? <Box>&#10003;</Box> : ""}
                  </Flex>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <button
        type="button"
        className="sort_btn"
        onClick={() =>{setOrder(!order);}}
      >
        <Box sx={{ color: order ? "blue" : "grey", fontSize: "10px" }}>&#9650;</Box>
        <Box sx={{ color: !order ? "blue" : "grey", fontSize: "10px" }}>&#9660;</Box>
      </button>
    </div>
  );
};

export default SortComp;
